// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DigitalAssetPagingResultModel from '../../model/digital-asset-paging-result-model';
import DigitalAssetPagingResultDTO from '../dto/digital-asset-paging-result-dto';
import dtoSchema from '../schemas/digital-asset-paging-result-schema';
import DigitalAssetModel from '../../model/digital-asset-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class DigitalAssetPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DigitalAssetPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => DigitalAssetModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: DigitalAssetModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<DigitalAssetPagingResultDTO>): DigitalAssetPagingResultModel;
  static toModel(dto: DeepPartial<DigitalAssetPagingResultDTO> | undefined | null): DigitalAssetPagingResultModel | undefined;
  static toModel(dto: DeepPartial<DigitalAssetPagingResultDTO> | undefined | null): DigitalAssetPagingResultModel | undefined {
    return dto ? new DigitalAssetPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DigitalAssetPagingResultModel> | DigitalAssetPagingResultModel): DigitalAssetPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as DigitalAssetPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DigitalAssetPagingResultModel, can not map to DigitalAssetPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
